export default {
  vibesDao: 'Vibes DAO'
}



// WEBPACK FOOTER //
// ./src/i18n/en/dao-community.js